<div class="ms-3 mb-2" [ngClass]="inTable? 'mt-0 ms-3':'mt-3'"   >
  @if (!inTable) {
    <label style="font-weight: 600;">{{select.name}}</label>
  }
  <select [(ngModel)]="selectValue" id="selectValue" class="form-control" name="selectValue"
    (change)="onChange($event)">
    @for (selectVal of targets; track selectVal) {
      <option value={{selectVal.key}}>
        {{selectVal.name}}
      </option>
    }
  </select>
</div>
